import React, { useRef } from 'react';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { textUtils } from '@instinet-analytics/core-lib';

import TilesSettings from 'widgets/tiles/components/toolbar/TilesSettings';
import { useWidgetContext } from 'widgets/WidgetContext';
import './TilesToolbar.scss';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useTilesConfigSlice } from 'widgets/tiles/store/config/configSlice';

import { Icon } from '@instinet-analytics/semantic-ui-components';
import { SymbolFromConfigOrPortfolioLinkedTitle } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedTitle';
import { ShareWidgetConfigToolbarButton } from 'widgets/configSharing/shareWidgetConfigModal/ShareWidgetConfigToolbarButton';

const { pluralise } = textUtils;

export interface TilesToolbarProps {
    toggleAddPanelVisibility: () => void;
}

export default function TilesToolbar(props: {
    toggleAddPanelVisibility: () => void;
}) {
    const { toggleAddPanelVisibility } = props;
    const { width } = useWidgetContext();
    const { config } = useTilesConfigSlice();
    const mustShow = config.tiles.length === 0;
    const ref = useRef<HTMLDivElement>(null);

    return (
        <WidgetToolbarShowHidePanel mustShow={mustShow}>
            <div
                className="TilesToolbar panel-header"
                style={{
                    width: width - 1 + 'px',
                }}
            >
                <div className="toolbar">
                    <div className="header">
                        <SymbolFromConfigOrPortfolioLinkedTitle />
                    </div>
                </div>

                <WidgetToolbar
                    fixedItems={
                        <div ref={ref} className="MenuDropdown">
                            <div
                                className="AddTileDropdownMenuItem"
                                onClick={toggleAddPanelVisibility}
                            >
                                <div className="text add-capsule-btn">
                                    Add Capsule
                                </div>
                                <Icon name="plus" />
                            </div>
                            <ShareWidgetConfigToolbarButton />
                        </div>
                    }
                    settingsHeader={`Capsule Container Settings`}
                    settingsBody={<TilesSettings />}
                    settingsTriggerText={`Capsule Container Settings`}
                    settingsClassName="TilesSettingsModal"
                    showEditLayout={true}
                    layoutEditingText={{
                        locked: `Remove ${pluralise(2, 'Capsule')} Disabled`,
                        unlocked: `Remove ${pluralise(2, 'Capsule')} Enabled`,
                    }}
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
